import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useLocalizeMessage, useDateTimeFormat } from 'libs.nucleus';
const DateTimeCell = ({ value }) => {
    const { formatDateTime } = useDateTimeFormat();
    if (!value) {
        return '';
    }
    return _jsx("span", { children: formatDateTime(value) });
};
export const useUserTrainingReportsTableColumn = () => {
    const translate = useLocalizeMessage();
    const trainingReportsColumns = useMemo(() => {
        return [
            {
                header: translate('Email'),
                accessorKey: 'email',
            },
            {
                header: translate('Version'),
                accessorKey: 'version',
            },
            {
                header: translate('Type'),
                accessorKey: 'type',
            },
            {
                header: translate('Study name'),
                accessorKey: 'studyName',
            },
            {
                header: translate('Completed on'),
                accessorKey: 'completedOn',
                cell: (context) => _jsx(DateTimeCell, { value: context.getValue() }),
            },
        ];
    }, []);
    return {
        columns: trainingReportsColumns,
    };
};
